export const asciiPattern = /^[\u0000-\u007F]*$/;
